"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/VideoRooms/Room/Modals/ApproveCallParticipant.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _Modal = require('web/components/Modal'); var _Modal2 = _interopRequireDefault(_Modal);
var _videoCallSoundEffects = require('web/services/videoCallSoundEffects');








const ApproveCallParticipantModal = ({
  isOpen,
  participantName,
  onAllow,
  onDeny,
}) => {
  // componentDidMount: the caller keys the modal by request, so the sound
  // plays once per join request.
  _react.useLayoutEffect.call(void 0, () => { _videoCallSoundEffects.playAskToJoin.call(void 0, ) }, [])

  return (
    _react2.default.createElement(_Modal2.default, {
      isOpen: isOpen,
      title: "Someone wants to join"   , __self: this, __source: {fileName: _jsxFileName, lineNumber: 23}}

      , _react2.default.createElement(_Modal.ModalDesc, { className: "meeting--remove-participant-modal--desc", __self: this, __source: {fileName: _jsxFileName, lineNumber: 27}}
        ,  participantName ? _react2.default.createElement('b', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 28}}, participantName) : 'Someone' 
        , ' ', "wants to join the meeting room."

      )
      , _react2.default.createElement(_Modal.ModalControls, {
        primaryBtnLabel: "Allow",
        isPrimaryEnabled: true,
        onPrimaryBtnClick: onAllow,
        secondaryBtnLabel: "Deny",
        onSecondaryBtnClick: onDeny, __self: this, __source: {fileName: _jsxFileName, lineNumber: 32}}
      )
    )
  )
}

exports. default = ApproveCallParticipantModal
